import axios from 'axios';
import { baseUrl, HttpMethods } from '../../base';
import type {
  IGetBulkUserInviteStatusService,
  IGetBulkUserInviteStatusServiceRes,
  IGetBulkUserInvitesService,
  IPatchCurrentUserProfileService,
  IPostBulkUserInviteService,
} from './types';

export async function postBulkUserInvite({ data }: IPostBulkUserInviteService) {
  const resp = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/bulkProcess`,
    data,
  });

  return resp.data;
}

export async function getBulkUserInviteStatus({
  batchId,
  params,
}: IGetBulkUserInviteStatusService): Promise<IGetBulkUserInviteStatusServiceRes> {
  const res = await axios.request<IGetBulkUserInviteStatusServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/bulkProcess/${batchId}`,
    params,
  });

  return res.data;
}

export async function getBulkUserInvites({ params }: IGetBulkUserInvitesService) {
  const resp = await axios({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/bulkProcess`,
    params,
  });
  return resp.data;
}

export async function patchCurrentUserProfile({ currentUserId, data }: IPatchCurrentUserProfileService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.TERMINAL}/user-management/users/${currentUserId}`,
    data,
  });
  return res.data;
}
